module.exports = __webpack_public_path__ + "static/media/securi-group.76b2c8cc.png";